import styled, { css } from "styled-components";
import { font } from "../../constants/font";
import { STATIC_PATH } from "../../constants/config";

const RIGHT_SECTION_HEIGHT = {
  vertical: "540px",
  horizontal: "534px",
  square: "534px",
};

const getRightSectionHeight = (dimensionName) =>
  RIGHT_SECTION_HEIGHT[dimensionName] || RIGHT_SECTION_HEIGHT.vertical;

export const Container = styled.div.attrs((props) => ({
  style: {
    "--sh-polarColor": props.theme.polarColor,
    "--sh-rgbaLightBlack2": props.theme.rgbaLightBlack2,
  },
}))`
  height: auto;
  width: ${({ isVertical }) => (isVertical ? "816px" : "1152px")};
  margin: 24px auto;
  display: flex;
  justify-content: ${({ isVertical }) =>
    isVertical ? "space-evenly" : "space-around"};
  align-items: start;
  background: var(--sh-polarColor) 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 3px var(--sh--rgbaLightBlack2);
  border-radius: 16px;
  gap: ${({ isVertical }) => (isVertical ? "0px" : "24px")};
  padding: ${({ isVertical }) => (isVertical ? "24px 24px 24px 0px" : "24px")};
  position: relative;
  @media screen and (min-width: 768px) and (max-width: 1189px) {
    width: 95%;
    height: auto;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 40px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  @media screen and (max-width: 767px) {
    width: 95%;
    height: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 24px 44px;
    gap: 12px;
  }
`;

export const PlayerLeftFrame = styled.div`
  width: fit-content;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    width: 100%;
    align-items: center;
  }
`;

export const LeftSection = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${(props) => (props.$hasWatermarkBar ? "12px 12px 0 0" : "8px")};
  background: #000;
  width: ${(props) => (props.$sizeToContent ? "auto" : "100%")};
  flex-shrink: 0;
`;

export const BackButton = styled.button`
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  z-index: 10;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export const PreviewContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

export const Preview = styled.video`
  position: absolute;
  display: none;
  object-fit: contain;
  pointer-events: auto;
  width: ${(props) => props.$width || "100%"};
  height: ${(props) => props.$height || "100%"};
  top: ${(props) => props.$top || "0px"};
  left: ${(props) => props.$left || "0px"};
`;

export const RightSection = styled.div`
  width: 50%;
  height: ${({ $dimensionName }) => getRightSectionHeight($dimensionName)};
  @media screen and (min-width: 768px) and (max-width: 1189px) {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    height: ${({ $inModal }) => ($inModal ? "auto" : "100%")};
  }
`;

export const Loader = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`;

export const Duration = styled.div`
  position: absolute;
  top: 8px;
  left: ${(props) => props.left || (props.right ? "auto" : "8px")};
  right: ${(props) => props.right || "auto"};
  z-index: 2;
  width: ${(props) => props.style?.width || "47px"};
  height: 22px;
  background: #1b1f21 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  font: ${font.normalMicroLarge_18};
  letter-spacing: 0px;
  color: ${(props) => props.theme.polarColor};
  padding: ${(props) => props.style?.padding || "0"};
  @media screen and (max-width: 767px) {
    left: ${(props) => (props.left || "8px")};
    right: ${(props) => props.right || "auto"};
  }
`;

export const Wrapper = styled.div`
  height: calc(100vh - 104px);
  background: ${(props) => props.theme.subtitleBgColor};
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  @media screen and (min-width: 768px) and (max-width: 1189px) {
    height: calc(100vh - 104px);
  }
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    height: 100%;
    overflow: visible;
    touch-action: pan-y;
  }
`;

export const PlayButton = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 8px;
  width: 100px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  z-index: 1;
  transform: translate(-50%, -50%);
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  transition: opacity 0.2s ease;
`;

export const ToolbarHeader = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  width: 100%;
  justify-content: space-between;
  margin: 0px auto;
  .subtitle-style {
    position: relative;
    border-radius: 8px;
    padding: 10px 24px 10px 34px;
    &:hover {
      background-color: ${(props) => props.theme.btnBgLightColor};
    }
    &:after {
      content: url(${STATIC_PATH}right-arrow.svg);
      position: absolute;
      right: 7px;
      top: 6px;
      transform: rotate(90deg);
    }
    &::before {
      content: url(${STATIC_PATH}sh-subtitle.svg);
      position: absolute;
      left: 8px;
      top: 8px;
    }
  }
  .expand-style {
    position: relative;
    border-radius: 8px;
    padding: 10px 24px 10px 34px;
    &:hover {
      background-color: ${(props) => props.theme.btnBgLightColor};
    }
    &:after {
      content: url(${STATIC_PATH}sidebar-expand.svg);
      position: absolute;
      right: 7px;
      top: 6px;
      transform: rotate(180deg);
    }
  }
  @media screen and (min-width: 768px) and (max-width: 992px) {
    width: 95%;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    height: auto;
    padding: 12px 0px 12px;
  }
`;

export const ResizeDropdown = styled.ul`
  background: ${(props) => props.theme.polarColor} 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 8px ${(props) => props.theme.rgbaLightBlack2};
  border: 1px solid ${(props) => props.theme.resizeBorder};
  border-radius: 8px;
  margin: 0;
  padding: 0;
  position: absolute;
  left: 0px;
  top: 25px;
  @media (max-width: 767px) {
    right: 0px;
    width: fit-content;
  }
`;

export const ResizeDropdownLi = styled.li`
  list-style: none;
  padding: 2px 0px 2px 15px;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  label {
    color: ${(props) =>
    props.isHovered
      ? props.theme.resizeHoverColor
      : props.theme.primaryColor};
  }
  &:hover {
    background-color: ${(props) => props.theme.btnBgLightColor};
    color: ${(props) => props.theme.resizeHoverColor};
    svg {
      * {
        fill: ${(props) => props.theme.resizeHoverColor};
        stroke: ${(props) => props.theme.resizeHoverColor};
      }
    }
    label {
      color: ${(props) => props.theme.resizeHoverColor};
      background-color: ${(props) => props.theme.btnBgLightColor};
    }
  }
`;

export const IconSVG = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.isSelected &&
    css`
      & #resizeContainer {
        fill: ${(props) => props.theme.svgIconLightColor};
        stroke: ${(props) => props.theme.svgIconColor};
      }
      & text {
        fill: ${(props) => props.theme.svgIconColor};
      }
    `}
  &:hover {
    & #resizeContainer {
      fill: ${(props) => props.theme.svgIconLightColor};
      stroke: ${(props) => props.theme.svgIconColor};
    }
    & text {
      fill: ${(props) => props.theme.svgIconColor};
    }
  }
`;

export const ToolbarWrap = styled.div`
  position: relative;
  border-radius: 6px;
  padding: 0px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: isActive;
  background-color: ${(props) => props.isActive && props.theme.liBgColor};
  .resizeDropdown {
    text-transform: capitalize;
    position: relative;
    border-radius: 6px;
    &:after {
      content: url(${STATIC_PATH}right-arrow.svg);
      position: absolute;
      right: 0px;
      top: 0;
      transform: rotate(90deg);
    }
    &:before {
      content: url(${STATIC_PATH}selectedIcon);
      position: absolute;
      left: 0px;
      top: 0px;
    }
  }
  .resizeMenu {
    display: none;
  }
  &:hover {
    background-color: ${(props) => props.theme.liBgColor};
    transform: scale(1.02);
    .resizeMenu {
      display: flex;
      flex-direction: column;
    }
  }
  a {
    text-decoration: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
  min-height: 0;
  position: relative;
`;

export const PanelOverlay = styled.div`
  display: ${(props) => (props.$showReframeLoading ? "block" : "none")};
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: auto;
  background: transparent;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;
  position: absolute;
  width: 55%;
  right: 24px;
  bottom: 12px;
  height: 48px;
  margin-top: auto;
`;
Footer.displayName = "Shorts Footer";

export const SocialMedia = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
  border-top: ${(props) =>
    props.isBorder ? `1px solid ${props.theme.shortsBorderColor}` : "none"};
  border-bottom: ${(props) =>
    props.isBorder ? `1px solid ${props.theme.shortsBorderColor}` : "none"};
  list-style: none;
  margin: 0px;
  gap: 12px;
`;
export const Links = styled.li.attrs((props) => ({
  style: {
    "--backgroundColor": props.theme.subtitleBgColor,
  },
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  img {
    transition: all 1s;
    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const ContentHeader = styled.div.attrs((props) => ({
  style: {
    "--shortsBtnBgColor": props.theme.shortsBtnBgColor,
    "--polarColor": props.theme.polarColor,
    "--shortsBtnHoverColor": props.theme.shortsBtnHoverColor,
  },
}))`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 12px;
  .edit-project {
    position: relative;
    padding-left: 8px;
    background: var(--polarColor);
    &:hover {
      background: var(--shortsBtnBgColor);
    }
    &::before {
      content: url(${STATIC_PATH}vm-cut.svg);
      position: absolute;
      left: 6px;
      top: 6.5px;
    }
    &.is-loading {
      padding-left: 0;
      min-width: 36px;
      overflow: hidden;
      &::before {
        display: none;
      }
    }
  }
  .ai-reframe-btn {
    position: relative;
    &.is-loading {
      padding: 0;
      min-width: 36px;
      overflow: hidden;
    }
  }
  .export-project {
    position: relative;
    padding-left: 8px;
    &:hover {
      background: var(--shortsBtnHoverColor);
    }
    &::before {
      content: url(${STATIC_PATH}vm-upload.svg);
      position: absolute;
      left: 7px;
      top: 7px;
    }
    &.is-loading {
      padding-left: 0;
      min-width: 36px;
      overflow: hidden;
      &::before {
        display: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    justify-content: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
`;

export const CardLoaderSpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: cardLoaderSpin 0.8s linear infinite;

  @keyframes cardLoaderSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const WorkspaceLoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 25;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  border-radius: inherit;
`;

export const ContentBody = styled.div`
  height: 100%;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 767px) {
    margin: 0px 0px 19px 0px;
  }
  position: relative;

  ${(props) => props.$isPanelBlocked && css`
    pointer-events: none;
  `}

  &::after {
    ${(props) => props.$isPanelBlocked && css`
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
    `}
  }
`;

export const Icon = styled.img``;

export const ClipEntry = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 0px 0px 16px;
  gap: 4px;
  &:last-child {
    margin-bottom: 0;
  }
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ClipTimestamp = styled.span`
  font: ${font.medium_12};
  color: ${(props) => props.color};
  letter-spacing: 0px;
  width: 18%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ClipText = styled.p`
  margin: 0;
  font: ${font.normalBase_19};
  color: ${(props) => props.color};
  line-height: 1.5;
  width: 100%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 6px;
  margin-right: auto;
  @media only screen and (max-width: 767px) {
    margin-right: unset;
  }
`;

export const CategoryPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  background: ${(props) => props.theme.subtitleBgColor};
  border-radius: 20px;
  text-transform: capitalize;
  letter-spacing: 0px;
`;

export const HdBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-top: 16px;
  background: #fff5e9;
  border-radius: 10px;
`;

export const HdBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 24px;
  padding: 0 6px;
  background: #FFF5E9;
  border-radius: 6px;
`;

export const HdBannerText = styled.span`
  font: ${font.mediumBase_21};
  color: #83643c;
  line-height: 21px;
  flex: 1;
  min-width: 0;
`;

export const HdBannerLink = styled.span`
  font: ${font.normalMini_14_700};
  color: #5d38ff;
  cursor: pointer;
  padding-left: 4px;
`;

export const ViralSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  margin-top: 12px;
  background: #f8f5ff;
  border-radius: 12px;
`;

export const ViralHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ViralTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ViralFeatureGrid = styled.div`
  display: flex;
  gap: 8px;
  @media screen and (max-width: 767px) {
   flex-wrap: wrap;
  }
`;

export const ViralFeatureCardWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  @media screen and (max-width: 767px) {
    flex: 1 1 100%;
  }
`;

export const ViralFeatureBadge = styled.span`
  position: absolute;
  ${(props) =>
    props.$variant === "comingSoon"
      ? "bottom: -6px; right: 50%; transform: translateX(50%);"
      : "top: -8px; right: 0px;"}
  z-index: 2;
  pointer-events: none;
   @media screen and (max-width: 767px) {
      ${(props) =>
    props.$variant === "comingSoon"
      ? "top: -6px; right: 20%; transform: translateX(50%);"
      : "top: -2px; right: 6px;"}
      height: 20px;
    }
  ${(props) =>
    props.$variant === "comingSoon" &&
    `
    padding: 2px 8px;
    border-radius: 10px;
    background: ${props.theme.shortsComingSoonColor};
    font: ${font.normalMicro};
    color: #ffffff;
    line-height: 1.2;
    white-space: nowrap;
  `}

  img {
    display: block;
    width: ${(props) => (props.$variant === "teams" ? "24px" : "20px")};
    height: ${(props) => (props.$variant === "teams" ? "24px" : "20px")};
  }
`;

export const ViralFeatureCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 14px 8px;
  background: #ffffff;
  border: 1px solid ${(props) => (props.$isActive ? "#6366f1" : "transparent")};
  border-radius: 10px;
  box-shadow: ${(props) =>
    props.$isActive ? "0 0 0 1px rgba(99, 102, 241, 0.2)" : "none"};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  opacity: 1;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover:not(:disabled) {
    border: 1px solid #C39AFF !important;
    background: #FFF;
    box-shadow: 0 3px 8px 0 rgba(93, 56, 255, 0.24);
  }
`;

export const FeatureIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${(props) => props.$bgColor};

  img {
    width: 20px;
    height: 20px;
  }
`;

export const ConfidenceScore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 8px;
  background: #1a1a1a;
  border-radius: 8px;
  font-size: ${font.bold_16};
  color: #4ade80;
  background: rgb(245, 246, 250);
  border-radius: 8px;
`;

export const ReframeInlineProgress = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  line-height: 0;
  flex-shrink: 0;
  width: 100%;
`;

export const ReframeInlineProgressBar = styled.div`
  background: #E5E2EA;
  height: 8px;
  width: 100%;
  max-width: 260px;
  border-radius: 6px;
  margin: 0;
  grid-column: 1;
  grid-row: 1;
`;

export const ReframeInlineProgressFill = styled.div`
  height: 8px;
  border-radius: 6px;
  margin: 0;
  grid-column: 1;
  grid-row: 1;
  background: linear-gradient(90deg, #64D6FF 0%, #B37BFF 50%, #FF6CD8 75%, #FF71D2 100%);
  transition: width 0.3s ease;
`;

export const ReframeSection = styled.div`
  display: flex;
  align-items: ${props => props.align || "center"};
  gap: 16px;
  padding: 16px;
  margin-top: 12px;
  background: #f8f5ff;
  border: 1.5px solid #c4b5fd;
  border-radius: 16px;
  .ai-reframe-btn {
  img{
    left: 20px !important;
  }
  }
`;

export const ReframeIcon = styled.img`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  animation: reframeFloat 2.5s ease-in-out infinite;

  @keyframes reframeFloat {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-2px);
    }
  }
`;

export const ReframeContentCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
  animation: reframeFadeIn 0.4s ease-in-out;

  @keyframes reframeFadeIn {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ReframeTextRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
